import { useModals } from 'almanac-ui/Modal'
import { ArticleService } from 'api/services/ArticleService'
import { type EditorView } from 'prosemirror-view'
import { openMediaUploadPrompt } from 'proseShared/prompts/MediaUploadPrompt/MediaUploadPrompt'
import { MAIN_CONTENT_ID } from 'screens/ProseEdit/Constants'
import { reportError } from 'utils/error'

export const useOpenCoverImagePrompt = (view: EditorView, articleId: string) => {
  const stackManager = useModals()
  const openPrompt = async () => {
    try {
      const image = await openMediaUploadPrompt({ view, stackManager })

      if (image) {
        await ArticleService.updateArticle(articleId, { cover_image_url: image[0].url, is_default_cover_image: false })

        document.getElementById(MAIN_CONTENT_ID)?.scrollTo({ top: 0, behavior: 'smooth' })
      }
    } catch (error) {
      reportError('Failed to open Image prompt in Neruda', {
        severity: 'error',
        metaData: { error },
      })
    }
  }
  return openPrompt
}
